import './Collapsible.css';
import { Icons } from '@/assets/icons/icons';
import {
  Collapsible as CollapsiblePrimitive,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/Collapsible';
import { cn } from '@/lib/utils';

import {
  DETAILS_TRIGGER_CLASS,
  ICON_SM_CLASS,
  sizingClass,
  TEXT_STYLE,
  TONE_CLASS,
} from '../tokens';

import type { catalog } from '@littlebird/action-cards-view';
import type { ComponentFn } from '@littlebird/action-cards-view/react';

const LINK_TRIGGER_CLASS = cn(
  'group inline-flex min-w-0 items-center gap-[var(--ac-gap-xs)] text-left underline-offset-2 transition-colors duration-[120ms] hover:text-foreground hover:underline motion-reduce:duration-[60ms]',
  TEXT_STYLE.meta,
  TONE_CLASS.muted
);

// The app's own disclosure, left uncontrolled: Radix owns the open/closed state,
// seeded once from `defaultOpen`. That prop is the initial value only — the open
// state afterward is local UI, never written back
export const Collapsible: ComponentFn<typeof catalog, 'Collapsible'> = ({
  props,
  children,
}) => {
  const appearance = props.appearance ?? 'details';

  return (
    <CollapsiblePrimitive
      defaultOpen={props.defaultOpen}
      className={cn('min-w-0', sizingClass(props.sizing))}
    >
      <CollapsibleTrigger
        className={
          appearance === 'link' ? LINK_TRIGGER_CLASS : DETAILS_TRIGGER_CLASS
        }
      >
        <Icons.chevronRight
          aria-hidden="true"
          className={cn(
            ICON_SM_CLASS,
            'shrink-0 transition-transform duration-[120ms] group-data-[state=open]:rotate-90 motion-reduce:duration-[60ms]'
          )}
        />
        <span className="min-w-0 truncate">{props.title}</span>
      </CollapsibleTrigger>
      <CollapsibleContent className="card-disclosure pt-[calc(6*var(--ac-u))]">
        {children}
      </CollapsibleContent>
    </CollapsiblePrimitive>
  );
};
